import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { UIRouterModule } from '@uirouter/angular';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { ComponentsModule } from '../components/components.module';
import { SharedModule } from '../shared/shared.module';

import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { AiCreditsComponent } from '../components/ai-credits/ai-credits.component';
import { AiTopOffComponent } from '../components/ai-top-off/ai-top-off.component';
import { NoResultsComponent } from '../components/no-results/no-results.component';
import { NotificationAlertComponent } from '../components/notification-alert/notification-alert.component';
import { CompanyAddComponent } from './components/company-add/company-add.component';
import { CompanyDetailsComponent } from './components/company-details/company-details.component';
import { CompanyFieldsComponent } from './components/company-fields/company-fields.component';
import { CompanyLicenseItemComponent } from './components/company-license-item/company-license-item.component';
import { CompanyLicenseTotalsComponent } from './components/company-license-totals/company-license-totals.component';
import { CompanyLicensesComponent } from './components/company-licenses/company-licenses.component';
import { IntegrationsComponent } from './components/integrations/integrations.component';
import { MoveCompanyComponent } from './components/move-company/move-company.component';
import { SettingsTabsComponent } from './components/settings-tabs/settings-tabs.component';
import { SSOSettingsComponent } from './components/sso-settings/sso-settings.component';
import { UserAddComponent } from './components/user-add/user-add.component';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { UserFieldsComponent } from './components/user-fields/user-fields.component';
import { UserListComponent } from './components/user-list/user-list.component';
import { routes } from './settings.routes';
import { ViewportComponent } from './viewport/viewport.component';

@NgModule({
  declarations: [
    ViewportComponent,
    MoveCompanyComponent,
    CompanyFieldsComponent,
    UserFieldsComponent,
    UserListComponent,
    SSOSettingsComponent,
    IntegrationsComponent,
    CompanyAddComponent,
    CompanyDetailsComponent,
    UserAddComponent,
    UserDetailsComponent,
    CompanyLicensesComponent,
    CompanyLicenseItemComponent,
    CompanyLicenseTotalsComponent,
  ],
  imports: [
    UIRouterModule.forChild(routes),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    SharedModule,
    PopoverModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatBottomSheetModule,
    MatListModule,
    MatButtonModule,
    MatMenuModule,
    MatTabsModule,
    NotificationAlertComponent,
    MatDialogModule,
    SettingsTabsComponent,
    MatTableModule,
    NoResultsComponent,
    AiTopOffComponent,
    AiCreditsComponent,
  ],
  exports: [],
})
export class SettingsModule {
  static providers = [];
}
